import { apiGet } from 'api';
import { GetExceptionLogsRequest, GetExceptionLogsResponse } from '../fragments';

export const getExceptionLogs = (
  request: GetExceptionLogsRequest
): Promise<GetExceptionLogsResponse> =>
  apiGet<GetExceptionLogsResponse, GetExceptionLogsRequest>('exceptions', request);
